<template>
  <div class="qlbh">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách phụ lục phí Visa</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="gets">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="pt-1 font-size-12 time-placeholder">
                  Thời gian
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              v-model.trim="search.keySearch"
              type="text"
              placeholder="Từ khóa"
              style="border-radius: 4px"
              @keyup.enter="gets()"
            />
          </div>
          <div class="form-group">
            <select2-multiple-control
              class="sales-manager"
              v-model="search.regionIds"
              :options="dataConfigRegion"
              :settings="{ placeholder: 'Vùng kinh doanh' }"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.formContract"
              :options="formContract"
              placeholder="Hình thức"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeCustomer"
              :options="customerType"
              placeholder="Loại hợp đồng"
            />
          </div>
          <div class="form-group" v-if="['PAYMENT', null].includes(defaultGroupService)">
            <Select2 v-model="search.superiorId" :options="listUser" placeholder="NV quản lý" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.saleId" :options="listUser" placeholder="NV triển khai" />
          </div>
          <div class="form-group">
            <Select2
              placeholder="Trạng thái trên MNP"
              v-model="search.state"
              :options="listStatusContract"
            />
          </div>
          <div class="form-group">
            <Select2
              placeholder="Trạng thái trên MPOS"
              v-model="search.mposStt"
              :options="Config.mposStt"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.approverId"
              :options="listUser"
              placeholder="Người duyệt/từ chối"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              type="button"
              @click="gets()"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="clearSearch()"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div
              v-if="hasDefaultFilter"
              class="mb-2 d-inline-flex align-items-center"
              style="
                background-color: #fff3e0;
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
              <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                @click="removeDefaultFilter"
                type="button"
                class="ml-2 btn-close-filter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0 4px;
                  color: #e65100;
                  font-size: 16px;
                  line-height: 1;
                "
                title="Bỏ lọc"
              >
                ×
              </button>
            </div>
            <div>
              Tổng hợp đồng:
              <strong class="text-primary">{{
                objectCount.totalContract ? objectCount.totalContract : 0
              }}</strong>
              &nbsp;&nbsp;| &nbsp;&nbsp; Chưa ký:
              <strong class="text-primary">{{
                objectCount.totalNotSign ? objectCount.totalNotSign : 0
              }}</strong>
              &nbsp;&nbsp;| &nbsp;&nbsp; Đã ký:
              <strong class="text-primary">{{
                objectCount.totalSigned ? objectCount.totalSigned : 0
              }}</strong>
            </div>
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="listContract"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(merchant)="data">
                <p>
                  <span>{{
                    data.item.merchantData ? data.item.merchantData.merchantName : ''
                  }}</span>
                </p>
                <p>
                  <a href="#">{{ data.item.merchantData ? data.item.merchantData.email : '' }}</a>
                </p>
                <p>
                  <a href="#">{{
                    data.item.merchantData ? data.item.merchantData.mobile : '' | encryptPhone
                  }}</a>
                </p>
                <p>
                  <span
                    >{{ data.item.merchantData ? data.item.merchantData.address : '' }},
                    {{ data.item.merchantData ? data.item.merchantData.district : '' }},
                    {{ data.item.merchantData ? data.item.merchantData.city : '' }}</span
                  >
                </p>
                <p><Status :value="data.item.mcLvl" :config="Config.mcKeyLvl" /></p>
              </template>
              <template #cell(time)="data">
                <p>
                  HĐ:
                  <span>{{
                    data.item.typeCustomer ? data.item.typeCustomer : '' | fomatCustomtype
                  }}</span>
                </p>
                <p>
                  Số: <b>{{ data.item.code }}</b>
                </p>
                <p
                  v-if="
                    data.item.dateCreate &&
                    contractStateOther.includes(data.item.status) &&
                    data.item.formContract === 'E_CONTRACT'
                  "
                >
                  Ngày tạo: <span>{{ data.item.dateCreate | formatDate }}</span>
                </p>
                <p v-if="data.item.approvedOrRejectedDate">
                  Ngày duyệt/từ chối:
                  <span>{{ data.item.approvedOrRejectedDate | formatDate }}</span>
                </p>
                <p
                  v-else-if="
                    data.item.dateSign &&
                    ((contractStateSign.includes(data.item.status) &&
                      data.item.formContract === 'E_CONTRACT') ||
                      data.item.formContract === 'PAPER_CONTRACT') &&
                    data.item.status !== 'CANCELED'
                  "
                >
                  Ngày ký: <span>{{ data.item.dateSign | formatDate }}</span>
                </p>
                <p v-else-if="data.item.dateCancel && data.item.status === 'CANCELED'">
                  Ngày huỷ: <span>{{ data.item.dateCancel | formatDate }}</span>
                </p>
              </template>
              <template #cell(sale)="data">
                <p>
                  <b>{{ data.item.saleInfo ? data.item.saleInfo.name : '' }}</b>
                </p>
                <p>
                  <a href="#">{{ data.item.saleInfo ? data.item.saleInfo.userName : '' }}</a>
                </p>
                <p>{{ data.item.saleInfo ? data.item.saleInfo.regionName : '' }}</p>
              </template>
              <template #cell(approvedOrRejectedExecutor)="data">
                {{ getNameApprovedOrRejectedExecutor(data.item.approvedOrRejectedExecutor) }}
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status ? data.item.status : '']">
                  {{ data.item.status | mapTextStatus(listStatusContract) }}</span
                >
                <br />
                {{ data.item.stateCollaborator | mapTextStatus(listStateCollaborator) }}
              </template>
              <template #cell(reason)="data">
                <span
                  v-if="data.item.status === 'REJECTED_SA' || data.item.status === 'REJECTED_MA'"
                >
                  <p
                    class="form-control-plaintext f12"
                    v-if="
                      data.item.reasonRejected &&
                      data.item.reasonRejected[data.item.reasonRejected.length - 1]
                    "
                  >
                    {{
                      data.item.reasonRejected
                        ? data.item.reasonRejected[data.item.reasonRejected.length - 1]
                        : ''
                    }}
                  </p>
                  <p class="form-control-plaintext f12" v-else>
                    {{
                      data.item.reasonRejectedBYMPOS
                        ? data.item.reasonRejectedBYMPOS[data.item.reasonRejectedBYMPOS.length - 1]
                        : ''
                    }}
                  </p>
                </span>
                <span v-if="data.item.status === 'ADDITIONAL'">
                  <p v-if="data.item.reasonAddImage && data.item.reasonAddImage[0]">
                    {{ data.item.reasonAddImage[0] }}
                  </p>
                  <p v-else-if="data.item.reasonAddInfo && data.item.reasonAddInfo[0]">
                    {{ data.item.reasonAddInfo[0] }}
                  </p>
                  <p v-else-if="data.item.reasonRejected && data.item.reasonRejected[0]">
                    {{ data.item.reasonRejected[0] }}
                  </p>
                </span>
              </template>
              <template #cell(statusMpos)="data">
                <span class="badge" :class="data.item.mposStt ? data.item.mposStt : ''">
                  {{ data.item.mposStt | transformData(Config.mposStt) }}
                </span>
                <br />
                <p v-if="data.item.mposModifiedDate">
                  Cập nhật: {{ data.item.mposModifiedDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  class="text-center"
                  variant="outline-light"
                  v-if="dataPermission && dataPermission.includes('CNPS_SCON_INFO_BY_CODE')"
                >
                  <b-dropdown-item
                    type="button"
                    class="dropdown-item"
                    @click="openModalDetail(data.item)"
                  >
                    <i class="bx bx-show-alt"></i> Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    type="button"
                    class="dropdown-item"
                    v-if="
                      canAccessMx('CNPS_SCON_REJECT_VISA_APPENDIX') &&
                      ['APPROVED', 'PENDING_APPROVAL', 'ACTIVE'].includes(data.item.status) &&
                      data.item.mposStt === 'NOT_CONFIGURED'
                    "
                    @click="rejectAppendixVisa(data.item.appendixId)"
                  >
                    <i class="bx bx-x-circle"></i> Từ chối
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="totalRows"
          :per-page="search.limit"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import Config from '../../thirdParty/config'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import { ContractService } from '../../services/contract.service'
  import { getLastNDays } from '@/utils/util'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'merchant', label: 'Merchant', thStyle: 'min-width: 130px' },
    { key: 'time', label: 'Hợp đồng/Ngày ký', thStyle: 'min-width: 280px' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'reason', label: 'Lý do MNP', class: 'text-center' },
    { key: 'statusMpos', label: 'Trạng thái PL trên MPOS' },
    { key: 'mposReason', label: 'Lý do MPOS', class: 'text-center' },
    { key: 'sale', label: 'Sale' },
    { key: 'approvedOrRejectedExecutor', fixIndex: 999, label: 'Người duyệt/từ chối' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        defaultGroupService: this.$route.query.groupService ?? null,
        textNote: '',
        dateRange: {
          startDate: null,
          endDate: null,
        },
        search: {
          limit: 15,
          page: 1,
        },
        dataConfigRegion: [],
        formContract: Config.formContract,
        customerType: Config.customerType,
        listUser: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        listStatusContract: Config.listStatusContract,
        listContract: [],
        objectCount: {},
        totalRows: 0,
        listStateCollaborator: [
          { id: 0, text: 'Tất cả' },
          { id: 'APPROVED', text: 'GS đã duyệt' },
          { id: 'WAITING', text: 'Chờ GS duyệt' },
          { id: 'REJECTED', text: 'GS từ chối' },
        ],
        loading: false,
        showLoading: false,
        contractStateSign: [
          'SIGNED_MISS_IMAGE',
          'SIGNED_WAITING_APPROVED',
          'APPROVED',
          'LIQUIDATE',
          'REJECTED_SA',
          'ADDITIONAL',
        ],
        contractStateOther: [
          'NEW',
          'WAITING_APPROVED_FEE',
          'APPROVED_FEE',
          'SENT',
          'WAITING_SIGN',
          'SIGNING',
          'REJECTED_MC',
          'REJECTED_MA',
        ],
        hasDefaultFilter: true,
      }
    },

    watch: {
      'search.page': function () {
        this.gets()
      },
      'search.limit': function () {
        this.gets()
      },
    },

    created() {
      const { from, to } = getLastNDays(3, 'date')
      this.dateRange = {
        startDate: from,
        endDate: to,
      }
      this.getRegions()
      this.getListStaffBySuperior()
      this.gets()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            const dataUser = [
              {
                id: 0,
                text: 'Tất cả',
              },
            ]
            data.data.map(e => {
              const body = {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
              dataUser.push(body)
            })
            this.listUser = dataUser
            return
          }
          this.listUser = []
        } catch (error) {
          console.log(error)
        }
      },

      openModalDetail(data) {
        if (data.groupService === 'SELL') {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/sales-manager/detail/${encodeURIComponent(data.id)}`, '_blank')
          } else {
            window.open(`/sales-manager/detail-paper/${encodeURIComponent(data.id)}`, '_blank')
          }
        } else {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/contract-detail-ecommerce/${encodeURIComponent(data.id)}`, '_blank')
          } else {
            window.open(`/contract-detail-paper/${encodeURIComponent(data.id)}`, '_blank')
          }
        }
      },

      clearSearch() {
        this.search = {
          page: 1,
          limit: 15,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.hasDefaultFilter = false
        this.gets()
      },

      removeDefaultFilter() {
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.hasDefaultFilter = false
        this.gets()
      },

      async getRegions() {
        const dataRes = await StaffService.getRegions()
        if (dataRes.data.length > 0) {
          const dataRegion = [
            {
              id: 0,
              text: 'Tất cả',
            },
          ]
          dataRes.data.map(e => {
            dataRegion.push({ id: e.id, text: e.name })
          })
          this.dataConfigRegion = dataRegion
        }
      },

      async formatData() {
        if (this.dateRange.endDate) {
          this.search.dateTo = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
        } else delete this.search.dateTo
        if (this.dateRange.startDate) {
          this.search.dateFrom = moment(this.dateRange.startDate)
            .startOf('day')
            .add(7, 'hours')
            .valueOf()
        } else delete this.search.dateFrom

        for (const key in this.search) {
          if (this.search[key] === '0') delete this.search[key]
        }

        if (this.search.regionIds && this.search.regionIds.length === 0)
          delete this.search.regionIds

        if (this.search.regionIds && this.search.regionIds !== null) {
          this.search.regionIds.map((e, key) => {
            if (e === '0') {
              this.search.regionIds.splice(key, 1)
              if (this.search.regionIds.length === 0) {
                delete this.search.regionIds
              }
            }
          })
        }

        if (this.search.code && this.search.code.includes(' ')) {
          const index = this.search.code.indexOf(' ')
          const length = this.search.code.length
          const code = this.search.code.slice(0, index) + this.search.code.slice(index + 1, length)
          this.search.code = code
        }
      },

      async gets() {
        try {
          this.loading = true
          this.formatData()
          const data = await ContractService.getListAppendixVisa(this.search)
          if (data.code === 1000) {
            this.objectCount = {
              totalContract: data.totalPage.total,
              totalNotSign: data.data.totalNotSign,
              totalSigned: data.data.totalSigned,
            }
            this.totalRows = data.totalPage.total
            this.listContract = data.data.contractList
            return
          }
          this.listContract = []
        } catch (error) {
          console.log(error, '=========>')
        } finally {
          this.loading = false
        }
      },
      async rejectAppendixVisa(appendixId) {
        const { value: flag, note } = await this.rejectMx()
        if (flag !== true) return
        try {
          this.showLoading = true
          const response = await ContractService.rejectAppendixVisa({ appendixId, reason: note })
          if (response.code === 1000) {
            this.gets()
            return true
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },

      getNameApprovedOrRejectedExecutor(data) {
        return data?.name ?? ''
      },
    },
  }
</script>

<style>
  @media screen and (max-width: 480px) {
    .dropdown-menu {
      max-width: 100%;
    }
    .no-gutters {
      overflow-x: auto;
      max-width: 100%;
      margin: 0 auto;
    }
    .daterangepicker .drp-buttons .btn {
      margin-left: 0;
    }
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px;
  }

  .DONE,
  .ACTIVE {
    color: #fff;
    background-color: #007bff;
  }
  .PENDING_APPROVAL,
  .PENDING_CONFIRM_APPROVAL {
    color: #fff;
    background-color: #ffc107;
  }
  .CANCEL {
    color: #fff;
    background-color: #dc3545;
  }
  .btn-close-filter:hover {
    opacity: 0.7;
    transform: scale(1.1);
  }
</style>
